import { ActivityLogDetails, ActivityLogDetailsResponseDTO } from '../entities';

const activityLogDetailsResponseDTOtoActivityLogDetailsAdapter = (
  response: ActivityLogDetailsResponseDTO,
): ActivityLogDetails => {
  if (!response.body) {
    throw Error();
  }
  const { id, transaction, account, status, amount, currency, dateUpdated } = response.body;

  return new ActivityLogDetails(id, transaction, account, status, amount, currency, dateUpdated);
};

export { activityLogDetailsResponseDTOtoActivityLogDetailsAdapter };
